import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const FloatingContactButtons = () => {
  return (
    <>
      {/* 📞 CALL — RIGHT */}
      <a
        href="tel:9755724915"
        aria-label="Call"
        className="
          fixed right-4 bottom-16 z-[9999]
          w-12 h-12 rounded-full
          bg-blue-600 text-white
          flex items-center justify-center
          shadow-lg
          hover:scale-105 active:scale-95
          transition-transform
        "
      >
        <FaPhoneAlt className="text-xl" />
      </a>

      {/* 💬 WHATSAPP — LEFT */}
      <a
        href="https://wa.me/919755724915"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="
          fixed left-4 bottom-16 z-[9999]
          w-12 h-12 rounded-full
          bg-green-500 text-white
          flex items-center justify-center
          shadow-lg
          hover:scale-105 active:scale-95
          transition-transform
        "
      >
        <FaWhatsapp className="text-2xl" />
      </a>
    </>
  );
};

export default FloatingContactButtons;
